import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost, corporateHost } from "~/Utils";

interface DocumentDetailsResponse {
  id: number;
  airline_name: string;
  airline_code: string;
  image: string;
  published: boolean;
  created_at: string; 
  updated_at: string; 
  eraman_sync: boolean;
  corporate_sync: boolean;
  passenger_sync: boolean;
  magp_sync: boolean;
  field_project_airport: any;
  module_name: any
}

const fetchCentralisedAirlineImagesDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/airline-images/all-fields/${id}`);
  return response.data[0];
};

const useCentralisedAirlineImagesDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["centralisedAirlineImages", id],
      enabled: false,
      queryFn: () => {
        return fetchCentralisedAirlineImagesDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCentralisedAirlineImagesDetails };
